// src/admin/components/Money.tsx
import type { Ngwee } from '@/lib/types';
import { formatKwacha } from '@admin/utils/money';

export default function Money({
  amount, decimals = 2, muted,
}: { amount: Ngwee | null | undefined; decimals?: 0 | 2; muted?: boolean }) {
  if (amount == null) return <span className="tabular" style={{ color: 'var(--c-text-muted)' }}>—</span>;
  return <span className="tabular" style={{ color: muted ? 'var(--c-text-muted)' : undefined }}>{formatKwacha(amount, { decimals })}</span>;
}
